export enum Region {
	Row = "Row" as any,
	Usa = "Usa" as any
};

export const defaultRegion = Region.Row;

export function parseRegion(s: string | undefined | null): Region
{
	if(s === undefined || s === null)
		s = defaultRegion.toString();

	switch(s.toLowerCase())
	{
		case 'row': return Region.Row;
		case 'usa': return Region.Usa;
		default: return defaultRegion;
	}
}